export { default as RestockDateTemplate } from './RestockDateTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/restock-date/index.js